import { LayoutDashboard, FileText, LogOut, ArrowUpFromLine, ArrowDownToLine, History, MonitorDown } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useInstallation } from '../../../shared/pwa/installation';
import bioTransacLogo from '../../../stories/assets/bioTransac_03.png';

export function Sidebar() {
  const { logout, user } = useAuth();
  const { installable, installer } = useInstallation();

  // Menu à plat : les anciennes sous-entrées « Transactions » (Retraits,
  // Versements, Historique) sont désormais des menus de premier niveau.
  // Le menu « Paramètres » a été retiré.
  const menuItems = [
    { path: '/', label: 'Tableau de Bord', icon: LayoutDashboard, end: true },
    { path: '/withdrawals', label: 'Retraits', icon: ArrowUpFromLine },
    { path: '/deposits', label: 'Versements', icon: ArrowDownToLine },
    { path: '/history', label: 'Historique', icon: History },
    { path: '/reports', label: 'Rapports', icon: FileText },
  ];

  return (
    <aside className="w-64 bg-white border-r border-gray-200 h-screen flex flex-col fixed left-0 top-0">
      {/* Header */}
      <div
        className="p-4 border-b border-gray-200 flex flex-col items-center justify-center flex-shrink-0"
        style={{
          background: 'linear-gradient(to right, #d0e4d7ff, #bde8daff)',
          opacity: 1,
        }}
      >
        <img
          src={bioTransacLogo}
          alt="BIOTRANSAC Logo"
          className="h-12 w-auto object-contain mb-2"
          style={{ filter: 'drop-shadow(0 2px 4px rgba(255, 255, 255, 0.3))' }}
        />
        <h1 className="text-lg font-extrabold text-gray-900" style={{ letterSpacing: '0.05em' }}>
          BIOTRANSAC
        </h1>
      </div>

      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map(item => {
            const Icon = item.icon;

            return (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  end={item.end}
                  className={({ isActive }) =>
                    `w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive ? 'bg-[#EDFAFF] text-[#0B677E]' : 'text-gray-700 hover:bg-gray-100'
                    }`
                  }
                >
                  <Icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer : remonté du bas de l'écran et compacté pour rester visible sur les petits écrans */}
      <div
        className="border-t border-gray-200 flex-shrink-0"
        style={{ padding: '14px 16px 44px', background: 'linear-gradient(to bottom, #f9fafb, #ffffff)' }}
      >
        {/* Installation sur le poste : visible seulement quand le navigateur la propose */}
        {installable && (
          <button
            type="button"
            onClick={() => void installer()}
            title="Ajoute BIOTRANSAC sur le bureau et dans la barre des tâches"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
              padding: '9px 14px',
              marginBottom: 12,
              borderRadius: 10,
              border: '1px dashed #016951',
              background: '#ecfdf5',
              color: '#016951',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            <MonitorDown style={{ width: 17, height: 17 }} />
            Installer sur ce poste
          </button>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 14px',
            marginBottom: 12,
            borderRadius: 12,
            border: '1px solid #dbeafe',
            background: 'linear-gradient(to bottom right, #eff6ff, #ecfdf5)',
          }}
        >
          <div
            style={{
              width: 40,
              height: 40,
              flexShrink: 0,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(to bottom right, #2563eb, #059669)',
              boxShadow: '0 4px 10px rgba(5, 150, 105, 0.25)',
              color: 'white',
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {user ? (user.displayName || 'U').split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : 'U'}
          </div>
          <div style={{ minWidth: 0, lineHeight: 1.3 }}>
            <div
              style={{ fontSize: 14, fontWeight: 600, color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
              title={user?.displayName}
            >
              {user?.displayName || 'Nom utilisateur'}
            </div>
            <div style={{ fontSize: 12, color: '#4b5563' }}>{user?.username || ''}</div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>Banque de Côte d&apos;Ivoire</div>
          </div>
        </div>

        <button
          onClick={logout}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            padding: '10px 16px',
            borderRadius: 10,
            border: 0,
            background: 'linear-gradient(to right, #ef4444, #dc2626)',
            boxShadow: '0 4px 12px rgba(220, 38, 38, 0.25)',
            color: 'white',
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          <LogOut style={{ width: 18, height: 18, color: 'white' }} />
          <span style={{ color: 'white' }}>Se déconnecter</span>
        </button>
      </div>
    </aside>
  );
}
